import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { MapPin, Building2, ArrowRight, Server } from "lucide-react";
import ReactDOMServer from "react-dom/server";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";
import { useClientLevel } from "../../hooks/useClientLevel";
import { useEffect } from "react";

type ClientLocation = {
    coordinate: [number, number];
    client_id: number;
    client_name: string;
};

const data: ClientLocation[] = [
    {
        coordinate: [12.9716, 77.5946],
        client_id: 62,
        client_name: "Runners Software Technologies",
    },
    {
        coordinate: [40.7486274146881, -73.98570731839561],
        client_id: 62,
        client_name: "Runners Software Technologies",
    }
];

const getPinIcon = () =>
    L.divIcon({
        html: ReactDOMServer.renderToString(
            <div className="flex items-center justify-center">
                <div className="relative flex items-center justify-center">
                    <MapPin
                        className="h-8 w-8 text-orange-500 drop-shadow-[0_6px_18px_rgba(249,115,22,0.35)]"
                        fill="currentColor"
                        strokeWidth={1.8}
                    />
                    <div className="absolute top-[6px] flex items-center justify-center">
                        <Server className="h-3.5 w-3.5 text-white" strokeWidth={2.4} />
                    </div>
                </div>
            </div>
        ),
        className: "custom-client-marker",
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -28],
    });



export default function ClientSiteMap() {
    const defaultCenter: [number, number] =
        data[0]?.coordinate ?? [12.9716, 77.5946];
    const navigate = useNavigate();
    const level = useClientLevel();

    useEffect(() => {
        if (level.name !== 'global') {
            navigate('/dashboard')
        }
    }, [level])



    return (
        <div className="w-full px-4 py-3">
            <div className="mx-auto max-w-5xl rounded-2xl border border-white/10 bg-white dark:bg-[#111827] p-3 shadow-[0_12px_40px_rgba(0,0,0,0.35)]">
                <div className="mb-3 flex items-center justify-between rounded-xl border border-white/8 bg-white/[0.03] px-3 py-2">
                    <div className="flex items-center gap-2.5">
                        <div className="rounded-lg bg-orange-500/15 p-1.5 text-orange-400">
                            <Building2 className="h-4 w-4" />
                        </div>
                        <div>
                            <h2 className="text-sm font-semibold text-gray-900 dark:text-white">Client Site Map</h2>
                            <p className="text-[11px] text-gray-500 dark:text-gray-400">Mapped client location</p>
                        </div>
                    </div>

                    <div className="rounded-md border border-orange-500/20 bg-orange-500/10 px-2 py-1 text-[10px] font-medium text-orange-300">
                        {data.length} Site
                    </div>
                </div>

                <div className="flex justify-center">
                    <div className="w-full max-w-7xl rounded-xl border border-gray-200 dark:border-zinc-700/60 bg-white dark:bg-[#0b1220] p-2">
                        <div className="h-[600px] z-40 overflow-hidden rounded-lg border border-gray-200 dark:border-zinc-800">
                            <MapContainer
                                center={defaultCenter}
                                zoom={2}
                                minZoom={2}
                                scrollWheelZoom={true}
                                style={{ width: "100%", height: "100%" }}
                                className="z-40"
                            >
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    maxZoom={18}
                                />

                                {data.map((item) => (
                                    <Marker
                                        key={item.client_id}
                                        position={item.coordinate}
                                        icon={getPinIcon()}

                                    >
                                        <Popup>
                                            <div className="min-w-[200px]">
                                                <div className="mb-2 border-b border-gray-100 pb-2">
                                                    <div className="text-sm font-bold text-gray-800">
                                                        {item.client_name}
                                                    </div>
                                                    <div className="mt-1 text-xs text-gray-500">
                                                        Client ID: {item.client_id}
                                                    </div>
                                                </div>

                                                <div className="space-y-1 text-xs text-gray-600">
                                                    <div>Lat: {item.coordinate[0]}</div>
                                                    <div>Lng: {item.coordinate[1]}</div>
                                                </div>

                                                <button
                                                    onClick={() =>
                                                        navigate(`/digital-twin/model/${item.client_id}`)
                                                    }
                                                    className="mt-3 flex w-full items-center justify-center gap-1.5 rounded-md bg-orange-500 px-3 py-2 text-xs font-semibold text-white transition hover:bg-orange-600"
                                                >
                                                    Go to Model
                                                    <ArrowRight className="h-3.5 w-3.5" />
                                                </button>
                                            </div>
                                        </Popup>
                                    </Marker>
                                ))}
                            </MapContainer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}